export const userRole = [
  {
    name: "Client Management",
    roles: [
      { id: 9, name: "Client View" },
      { id: 10, name: "Client Create" },
      { id: 11, name: "Client Edit" },
      { id: 12, name: "Client Delete" },
      { id: 13, name: "Client Contracts" },
      { id: 14, name: "Client Inspection" },
      { id: 15, name: "Client equipments" },
      { id: 16, name: "Client Service" },
      { id: 17, name: "Client Invoice" },
      { id: 18, name: "Client Import" },
      { id: 19, name: "Client Export" },
      { id: 20, name: "Survey View" },
      { id: 21, name: "Survey Create" },
      { id: 22, name: "Survey Edit" },
      { id: 23, name: "Survey Delete" },
      { id: 24, name: "Survey Import" },
      { id: 25, name: "Survey Export" },
      { id: 26, name: "Survey Form View" },
      { id: 27, name: "Survey Form Edit" },
      { id: 28, name: "Contract View" },
      { id: 29, name: "Contract Create" },
      { id: 30, name: "Contract Edit" },
      { id: 31, name: "Contract Delete" },
      { id: 32, name: "Contract Import" },
      { id: 33, name: "Contract Export" },
      { id: 34, name: "Contract Inspection" },
      { id: 35, name: "Contract Equipments" },
      { id: 36, name: "Contract Service" },
      { id: 37, name: "Contract Invoice" }
    ]
  },
  {
    name: "Team",
    roles: [
      { id: 231, name: "View Team" },
      { id: 232, name: "Create Team" },
      { id: 233, name: "Edit Team" },
      { id: 234, name: "Delete Team" },
      { id: 235, name: "Import Team" },  // Corrected from 236 to 235
      { id: 236, name: "Export Team" },  // Corrected from 237 to 236
      { id: 237, name: "Team Availability" }  // Corrected from 242 to 237
    ]
  },
  {
    name: "Inspection",
    roles: [
      { id: 39, name: "Calendar View" },
      { id: 40, name: "Calendar Edit" },
      { id: 41, name: "Schedule View" },
      { id: 42, name: "Schedule Create" },
      { id: 43, name: "Schedule Edit" },
      { id: 44, name: "Schedule Delete" },
      { id: 45, name: "Schedule Import" },
      { id: 46, name: "Schedule Export" },
      { id: 47, name: "Schedule Form view" },
      { id: 48, name: "Schedule Form Edit" }
    ]
  },
  {
    name: "Commissioning",
    roles: [
      { id: 50, name: "Schedule View" },
      { id: 51, name: "Schedule Create" },
      { id: 52, name: "Schedule Edit" },
      { id: 53, name: "Schedule Delete" },
      { id: 54, name: "Schedule Import" },
      { id: 55, name: "Schedule Export" },
      { id: 56, name: "Schedule Form View" },
      { id: 57, name: "Schedule Form Edit" }
    ]
  },
  {
    name: "Refilling",
    roles: [
      { id: 59, name: "Fire Extinguisher View" },
      { id: 60, name: "Fire Extinguisher Create" },
      { id: 61, name: "Fire Extinguisher Edit" },
      { id: 62, name: "Fire Extinguisher Delete" },
      { id: 63, name: "Fire Extinguisher Import" },
      { id: 64, name: "Fire Extinguisher Export" },
      { id: 65, name: "Fire Extinguisher Form View" },
      { id: 66, name: "Fire Extinguisher Form Edit" },
      { id: 67, name: "Fire Suppression View" },
      { id: 68, name: "Fire Suppression Create" },
      { id: 69, name: "Fire Suppression Edit" },
      { id: 70, name: "Fire Suppression Delete" },
      { id: 71, name: "Fire Suppression Import" },
      { id: 72, name: "Fire Suppression Export" },
      { id: 73, name: "Fire Suppression Form View" },
      { id: 74, name: "Fire Suppression Form Edit" }
    ]
  },
  {
    name: "Tickets",
    roles: [
      { id: 76, name: "Client Ticket View" },
      { id: 77, name: "Client Ticket Create" },
      { id: 78, name: "Client Ticket Edit" },
      { id: 79, name: "Client Ticket Delete" },
      { id: 80, name: "Client Ticket Export" },
      { id: 81, name: "Support Ticket View" },
      { id: 82, name: "Support Ticket Edit" },
      { id: 83, name: "Support Ticket Delete" },
      { id: 84, name: "Support Ticket Export" }
    ]
  },
  {
    name: "Invoice Outgoing",
    roles: [
      { id: 87, name: "Invoice View" },
      { id: 86, name: "Invoice Create" },  // Note: This is out of order (86 comes before 87)
      { id: 88, name: "Invoice Edit" },
      { id: 89, name: "Invoice Delete" },
      { id: 90, name: "Invoice Import" },
      { id: 91, name: "Invoice Export" }
    ]
  },
  {
    name: "Task",
    roles: [
      { id: 229, name: "My-Task View" },
      { id: 230, name: "My-Task Edit" },
      { id: 93, name: "Task View" },
      { id: 160, name: "Task Create" },  // Note: This is out of sequence
      { id: 94, name: "Task Edit" },
      { id: 95, name: "Task Delete" },
      { id: 96, name: "Task Import" },
      { id: 97, name: "Task Export" }
    ]
  },
  {
    name: "Forms",
    roles: [
      { id: 99, name: "Form View" }
    ]
  },
  {
    name: "Email",
    roles: [
      { id: 101, name: "Email View" },
      { id: 102, name: "Email Delete" },
      { id: 103, name: "Email Export" }
    ]
  },
  {
    name: "Contact",
    roles: [
      { id: 105, name: "Main Contractor View" },
      { id: 106, name: "Main Contractor Create" },
      { id: 107, name: "Main Contractor Edit" },
      { id: 108, name: "Main Contractor Delete" },
      { id: 109, name: "Main Contractor Import" },
      { id: 110, name: "Main Contractor Export" },
      { id: 111, name: "Installer View" },
      { id: 112, name: "Installer Create" },
      { id: 113, name: "Installer Edit" },
      { id: 114, name: "Installer Delete" },
      { id: 115, name: "Installer Import" },
      { id: 116, name: "Installer Export" },
      { id: 122, name: "Supplier View" },
      { id: 117, name: "Supplier Create" },
      { id: 121, name: "Supplier Edit" },
      { id: 118, name: "Supplier Delete" },
      { id: 119, name: "Supplier Import" },
      { id: 120, name: "Supplier Export" },
      { id: 123, name: "Consultant View" },
      { id: 124, name: "Consultant Create" },
      { id: 125, name: "Consultant Edit" },
      { id: 126, name: "Consultant Delete" },
      { id: 127, name: "Consultant Import" },
      { id: 128, name: "Consultant Export" }
    ]
  },
  {
    name: "Report",
    roles: [
      { id: 212, name: "Report Client" },
      { id: 213, name: "Report Survey" },
      { id: 214, name: "Report Contract" },
      { id: 216, name: "Report Inspection Schedule" },
      { id: 218, name: "Report Commissioning Schedule" },
      { id: 220, name: "Report Refilling Extinguister" },
      { id: 221, name: "Report Refilling Suppression" },
      { id: 223, name: "Report Ticket Client" },
      { id: 224, name: "Report Ticket Support" },
      { id: 226, name: "Report Task" },
      { id: 228, name: "Report Invoice Outgoing" }
    ]
  },
  {
    name: "Settings",
    roles: [
      { id: 129, name: "Settings View" },
      { id: 130, name: "Company Info View" },
      { id: 131, name: "Company Info Create" },
      { id: 132, name: "Company Info Edit" },
      { id: 133, name: "Client Management Settings View" },
      { id: 134, name: "Client Management Settings Create" },
      { id: 135, name: "Client Management Settings Edit" },
      { id: 136, name: "Client Management Settings Delete" },
      { id: 137, name: "Inspection Settings View" },
      { id: 138, name: "Inspection Settings Create" },
      { id: 139, name: "Inspection Settings Edit" },
      { id: 140, name: "Inspection Settings Delete" },
      { id: 141, name: "Commissioning Settings View" },
      { id: 142, name: "Commissioning Settings Create" },
      { id: 143, name: "Commissioning Settings Edit" },
      { id: 144, name: "Commissioning Settings Delete" },
      { id: 145, name: "Refilling Settings View" },
      { id: 146, name: "Refilling Settings Create" },
      { id: 147, name: "Refilling Settings Edit" },
      { id: 148, name: "Refilling Settings Delete" },
      { id: 149, name: "Tickets Settings View" },
      { id: 150, name: "Tickets Settings Create" },
      { id: 151, name: "Tickets Settings Edit" },
      { id: 152, name: "Tickets Settings Delete" },
      { id: 153, name: "Invoice Settings View" },
      { id: 154, name: "Invoice Settings Create" },
      { id: 155, name: "Invoice Settings Edit" },
      { id: 156, name: "Invoice Settings Delete" },
      { id: 157, name: "Task Settings View" },
      { id: 160, name: "Task Settings Create" },  // Note: Duplicate ID with Task Create
      { id: 158, name: "Task Settings Edit" },
      { id: 159, name: "Task Settings Delete" },
      { id: 161, name: "Contact Settings View" },
      { id: 162, name: "Contact Settings Create" },
      { id: 163, name: "Contact Settings Edit" },
      { id: 164, name: "Contact Settings Delete" },
      { id: 165, name: "Equipment Settings View" },
      { id: 166, name: "Equipment Settings Create" },
      { id: 167, name: "Equipment Settings Edit" },
      { id: 168, name: "Equipment Settings Delete" },
      { id: 171, name: "Inspector Settings View" },
      { id: 172, name: "Inspector Settings Create" },
      { id: 173, name: "Inspector Settings Edit" },
      { id: 174, name: "Inspector Settings Delete" },
      { id: 175, name: "Role Settings View" },
      { id: 176, name: "Role Settings Create" },
      { id: 177, name: "Role Settings Edit" },
      { id: 178, name: "Role Settings Delete" },
      { id: 179, name: "User Settings View" },
      { id: 180, name: "User Settings Create" },
      { id: 181, name: "User Settings Edit" },
      { id: 182, name: "User Settings Delete" },
      { id: 183, name: "User Role Settings View" },
      { id: 184, name: "User Role Settings Create" },
      { id: 185, name: "User Role Settings Edit" },
      { id: 186, name: "User Role Settings Delete" },
      { id: 187, name: "Notification Settings View" },
      { id: 188, name: "Notification Settings Create" },
      { id: 189, name: "Notification Settings Edit" },
      { id: 190, name: "Notification Settings Delete" },
      { id: 197, name: "Email Server Settings View" },
      { id: 198, name: "Email Server Settings Edit" },
      { id: 199, name: "Email Template Settings View" },
      { id: 200, name: "Email Template Settings Create" },
      { id: 201, name: "Email Template Settings Edit" },
      { id: 202, name: "Email Template Settings Delete" },
      { id: 191, name: "Reference Number View" },
      { id: 192, name: "Reference Number Edit" },
      { id: 193, name: "Approval Permission View" },
      { id: 194, name: "Approval Permission Create" },
      { id: 195, name: "Approval Permission Edit" },
      { id: 196, name: "Approval Permission Delete" },
      { id: 203, name: "Approval Status View" },
      { id: 204, name: "Approval Status Create" },
      { id: 205, name: "Approval Status Edit" },
      { id: 206, name: "Approval Status Delete" }
    ]
  },
  {
    name: "Other",
    roles: [
      { id: 208, name: "Approvals" },
      { id: 209, name: "Client Details" }
    ]
  }
];